"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[40314],{

/***/ 36939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_toArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84506);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97685);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65122);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var _Collapse__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66037);
/* harmony import */ var _Paper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79895);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1591);
/* harmony import */ var _AccordionContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88078);
/* harmony import */ var _utils_useControlled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22775);














var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded': {
        margin: '16px 0',
        '&:first-child': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        },
        '&:before': {
          opacity: 0
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      },
      '&$disabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var Accordion = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Accordion(props, ref) {
  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      expandedProp = props.expanded,
      onChange = props.onChange,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);

  var _useControlled = (0,_utils_useControlled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'Accordion',
    state: 'expanded'
  }),
      _useControlled2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpandedState = _useControlled2[1];

  var handleChange = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (event) {
    setExpandedState(!expanded);

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);

  var _React$Children$toArr = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(childrenProp),
      _React$Children$toArr2 = (0,_babel_runtime_helpers_esm_toArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_React$Children$toArr),
      summary = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  var contextValue = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return {
      expanded: expanded,
      disabled: disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Paper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref: ref,
    square: square
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_AccordionContext__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Provider */ .Z.Provider, {
    value: contextValue
  }, summary), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props['aria-controls'],
    role: "region"
  }, children)));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(styles, {
  name: 'MuiAccordion'
})(Accordion));

/***/ }),

/***/ 88078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var AccordionContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (AccordionContext);

/***/ }),

/***/ 61201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1591);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var AccordionDetails = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function AccordionDetails(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(styles, {
  name: 'MuiAccordionDetails'
})(AccordionDetails));

/***/ }),

/***/ 50743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41810);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17812);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _Accordion_AccordionContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88078);



/* eslint-disable jsx-a11y/aria-role */







var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: theme.spacing(0, 2),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.action.focus
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var AccordionSummary = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function AccordionSummary(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      IconButtonProps = props.IconButtonProps,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocusVisible = props.onFocusVisible,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
      focusedState = _React$useState[0],
      setFocusedState = _React$useState[1];

  var handleFocusVisible = function handleFocusVisible(event) {
    setFocusedState(true);

    if (onFocusVisible) {
      onFocusVisible(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocusedState(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var _React$useContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_Accordion_AccordionContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
    onFocusVisible: handleFocusVisible,
    onBlur: handleBlur,
    onClick: handleChange,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiAccordionSummary'
})(AccordionSummary));

/***/ }),

/***/ 76220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
}), 'AddCircle');

exports.Z = _default;

/***/ }),

/***/ 69002:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
}), 'RemoveCircle');

exports.Z = _default;

/***/ }),

/***/ 79105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_InStoreManager; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./redux/actions/inStore.ts + 1 modules
var inStore = __webpack_require__(7766);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(85160);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: (0,colorManipulator/* fade */.U1)(theme.palette.divider, 0.08)
    },

    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: '100%',
      width: 1
    },

    /* Styles applied to the root element if `flexItem={true}`. */
    flexItem: {
      alignSelf: 'stretch',
      height: 'auto'
    }
  };
};
var Divider = /*#__PURE__*/react.forwardRef(function Divider(props, ref) {
  var _props$absolute = props.absolute,
      absolute = _props$absolute === void 0 ? false : _props$absolute,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'hr' : _props$component,
      _props$flexItem = props.flexItem,
      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
      _props$light = props.light,
      light = _props$light === void 0 ? false : _props$light,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$role = props.role,
      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);

  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
    role: role,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Divider_Divider = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiDivider'
})(Divider));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(29525);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(59000);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(61201);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(50743);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Accordion/Accordion.js
var Accordion = __webpack_require__(36939);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AddCircle.js
var AddCircle = __webpack_require__(76220);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/RemoveCircle.js
var RemoveCircle = __webpack_require__(69002);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
;// CONCATENATED MODULE: ./components/InStore/StoreList.tsx















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var mapDispatchToProps = {
    saveChosenStore: inStore/* saveChosenStore */.c3
};
var mapStateToProps = function(state) {
    return {
        cart: state.cart
    };
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            boxShadow: theme.shadows[3]
        },
        header: _defineProperty({
            padding: theme.spacing(0.5, 2),
            backgroundColor: theme.extraColors.greyLight
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0.5, 1)
        }),
        chooseButton: _defineProperty({
            padding: theme.spacing(1, 1.5)
        }, theme.breakpoints.down('sm'), {
            fontSize: '90%'
        }),
        row: {
            display: 'inline-flex',
            alignItems: 'center',
            height: '100%'
        },
        storeName: _defineProperty({
            fontWeight: 700,
            lineHeight: 1,
            marginRight: theme.spacing(0.5)
        }, theme.breakpoints.down('sm'), {}),
        toggleHeader: {
            display: 'flex',
            alignItems: 'center',
            fontSize: theme.typography.pxToRem(12)
        },
        toggleIcon: {
            width: '1.25rem',
            height: '1.25rem'
        },
        toggleText: _defineProperty({
            marginLeft: theme.spacing(1)
        }, theme.breakpoints.down('sm'), {
            marginLeft: theme.spacing(0.5),
            fontSize: '90%'
        }),
        cell: _defineProperty({}, theme.breakpoints.down('sm'), {
            fontSize: '70%',
            lineHeight: 1,
            '&:last-child': {
                display: 'flex',
                justifyContent: 'flex-end'
            }
        }),
        storeRow: {
            padding: theme.spacing(1, 0)
        },
        no_store: {
            width: '100%',
            textAlign: 'center'
        }
    });
});
var StoreList_Accordion = (0,withStyles/* default */.Z)(function(theme) {
    return {
        root: {
            border: "1px solid ".concat(theme.extraColors.greyLight),
            boxShadow: 'none',
            '&:not(:last-child)': {
                borderBottom: 0
            },
            '&:before': {
                display: 'none'
            },
            '&$expanded': {
                margin: 'auto'
            }
        },
        expanded: {}
    };
})(Accordion/* default */.Z);
var StoreList_AccordionSummary = (0,withStyles/* default */.Z)(function(theme) {
    return {
        root: _defineProperty({
            minHeight: 56,
            '&$expanded': {
                minHeight: 56
            }
        }, theme.breakpoints.down('sm'), {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1)
        }),
        content: {
            margin: theme.spacing(1, 0),
            '&$expanded': {
                margin: theme.spacing(1, 0)
            }
        },
        expanded: {}
    };
})(AccordionSummary/* default */.Z);
var StoreList_AccordionDetails = (0,withStyles/* default */.Z)(function(theme) {
    return {
        root: _defineProperty({}, theme.breakpoints.down('sm'), {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1)
        })
    };
})(AccordionDetails/* default */.Z);
var StoreList = function(param) {
    var stores = param.stores, saveChosenStore1 = param.saveChosenStore, handleClose = param.handleClose, doc = param.doc, t = param.t, origin = param.origin;
    var deleteCart = (0,useCart/* useCart */.j)().deleteCart;
    var classes = useStyles();
    var router = (0,next_router.useRouter)();
    var ref = _slicedToArray(react.useState(''), 2), expanded = ref[0], setExpanded = ref[1];
    var handleChange = function(store, event, newExpanded) {
        if (!store.useParcelAddress) return;
        setExpanded(newExpanded ? "panel".concat(store === null || store === void 0 ? void 0 : store.id) : undefined);
    };
    var saveChosenStoreAndClose = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(store) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return saveChosenStore1(store);
                    case 2:
                        _ctx.next = 4;
                        return deleteCart();
                    case 4:
                        if (origin && origin !== '/') {
                            router.push(origin);
                        }
                        handleClose();
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function saveChosenStoreAndClose(store) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.root,
            children: (stores === null || stores === void 0 ? void 0 : stores.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        className: classes.header,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 4,
                                lg: 3,
                                className: classes.cell,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    data: doc === null || doc === void 0 ? void 0 : doc.modale_shop_name,
                                    defaultText: t('texts:instore:modale_shop_name'),
                                    asText: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 4,
                                lg: 6,
                                className: classes.cell,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    data: doc === null || doc === void 0 ? void 0 : doc.modale_informations,
                                    defaultText: t('texts:instore:modale_informations'),
                                    asText: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 4,
                                lg: 3,
                                className: classes.cell,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    data: doc === null || doc === void 0 ? void 0 : doc.modale_choose_shop,
                                    defaultText: t('texts:instore:modale_choose_shop'),
                                    asText: true
                                })
                            })
                        ]
                    }),
                    stores === null || stores === void 0 ? void 0 : stores.map(function(store) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreList_Accordion, {
                            expanded: expanded === 'panel' + store.id,
                            onChange: handleChange.bind(null, store),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreList_AccordionSummary, {
                                    "aria-controls": "panel1d-content",
                                    id: "panel1d-header",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        container: true,
                                        alignItems: 'center',
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                item: true,
                                                xs: 4,
                                                lg: 3,
                                                className: classes.cell,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        component: 'h2',
                                                        variant: 'body2',
                                                        className: classes.storeName,
                                                        children: store.name
                                                    }),
                                                    store.distance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        color: 'secondary',
                                                        children: store.distance
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                xs: 4,
                                                lg: 6,
                                                className: classes.cell,
                                                children: store.useParcelAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.row,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: classes.toggleHeader,
                                                        children: [
                                                            expanded === 'panel' + store.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveCircle/* default */.Z, {
                                                                className: classes.toggleIcon,
                                                                color: 'primary'
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCircle/* default */.Z, {
                                                                className: classes.toggleIcon,
                                                                color: 'primary'
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: 'body2',
                                                                className: classes.toggleText,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: doc === null || doc === void 0 ? void 0 : doc.modale_details,
                                                                    defaultText: t('texts:instore:modale_details')
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                xs: 4,
                                                lg: 3,
                                                className: classes.cell,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    type: "submit",
                                                    className: classes.chooseButton,
                                                    variant: 'contained',
                                                    color: 'primary',
                                                    size: 'small',
                                                    onClick: function() {
                                                        return saveChosenStoreAndClose(store);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: doc === null || doc === void 0 ? void 0 : doc.modale_choose_button,
                                                        defaultText: t('texts:instore:modale_choose_button')
                                                    })
                                                })
                                            })
                                        ]
                                    }, store.id)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreList_AccordionDetails, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        container: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                xs: 12,
                                                lg: 3
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                item: true,
                                                xs: 12,
                                                lg: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        component: 'h3',
                                                        variant: 'h5',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                            children: [
                                                                ' ',
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: doc === null || doc === void 0 ? void 0 : doc.modale_address,
                                                                    defaultText: t('texts:instore:modale_address')
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        component: 'p',
                                                        variant: 'body2',
                                                        children: store.address
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        component: 'p',
                                                        variant: 'body2',
                                                        children: store.address_details
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        component: 'p',
                                                        variant: 'body2',
                                                        children: store.city + ' ' + store.zipcode + ' ' + (store.region !== null ? store.region : '')
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        component: 'h3',
                                                        variant: 'h5',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                            children: [
                                                                ' ',
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: doc === null || doc === void 0 ? void 0 : doc.modale_phone,
                                                                    defaultText: t('texts:instore:modale_phone')
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        component: 'p',
                                                        variant: 'body2',
                                                        children: store.phone
                                                    })
                                                ]
                                            })
                                        ]
                                    }, store.id)
                                })
                            ]
                        }, store.id));
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.no_store,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: 'div',
                    variant: 'body2',
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: doc === null || doc === void 0 ? void 0 : doc.no_store_available,
                        defaultText: t('instore:no_store_available')
                    })
                })
            })
        })
    }));
};
/* harmony default export */ var InStore_StoreList = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(StoreList));

;// CONCATENATED MODULE: ./utils/searchWarhouseByPostcode.tsx
var searchWarehouseByPostcode = function(warehouses, postcode) {
    var searchedWarehouses = [];
    warehouses === null || warehouses === void 0 ? void 0 : warehouses.map(function(warehouse) {
        var ref;
        if (((ref = warehouse.zipcode) === null || ref === void 0 ? void 0 : ref.slice(0, postcode.length)) === postcode) {
            searchedWarehouses.push(warehouse);
        }
    });
    return searchedWarehouses;
};

;// CONCATENATED MODULE: ./components/InStore/InStoreModal.tsx









function InStoreModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var InStoreModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        root: {
            '& .MuiDialog-paper': {
                borderRadius: 0
            }
        },
        container: (_obj = {}, InStoreModal_defineProperty(_obj, theme.breakpoints.up('md'), {
            minWidth: theme.breakpoints.width('md')
        }), InStoreModal_defineProperty(_obj, theme.breakpoints.up('lg'), {
            minWidth: theme.breakpoints.width('lg')
        }), _obj),
        closeButton: {
            width: '100%',
            display: 'inline-flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: theme.extraColors.greyLight
        },
        cross: {
            cursor: 'pointer',
            height: 32,
            width: 32,
            padding: theme.spacing(0.5),
            color: theme.palette.common.white,
            backgroundColor: theme.extraColors.grey,
            borderRadius: '50%',
            margin: theme.spacing(1)
        },
        titleInHeader: InStoreModal_defineProperty({
            padding: theme.spacing(3),
            margin: 0
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(1.5, 1)
        }),
        search: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end'
        },
        marginLeft: {
            marginLeft: theme.spacing(1)
        },
        dialogContent: InStoreModal_defineProperty({
            padding: theme.spacing(3)
        }, theme.breakpoints.down('sm'), {
            padding: 0
        }),
        searchButton: {
            margin: theme.spacing(0, 0, 2, 1)
        }
    });
});
var InStoreModal_mapStateToProps = function(state) {
    return {
        stores: state.stores,
        parameters: state.parameters,
        doc: state.prismic.instore
    };
};
var InStoreModal = function(param) {
    var stores = param.stores, parameters = param.parameters, t = param.t, doc = param.doc;
    var ref5, ref1;
    var theme = (0,useTheme/* default */.Z)();
    var classes = InStoreModal_useStyles();
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var ref3 = (0,react.useState)(''), postCode = ref3[0], setPostCode = ref3[1];
    var ref4 = (0,react.useState)(parameters === null || parameters === void 0 ? void 0 : (ref5 = parameters.items) === null || ref5 === void 0 ? void 0 : ref5.stores), searchedWarehouse1 = ref4[0], setSearchedWarehouse = ref4[1];
    var handleClose = function() {
        setOpen(false);
    };
    var searchStoreOnEnter = function(event) {
        if (event === 'Enter') {
            searchStore();
        }
    };
    var searchStore = function() {
        var ref;
        // call api to find stores by postal code, deactivated
        var searchedWarehouse = searchWarehouseByPostcode(parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.stores, postCode);
        setSearchedWarehouse(searchedWarehouse);
    };
    var setPostCodeFunction = function(value) {
        if ((value === null || value === void 0 ? void 0 : value.length) <= 5) {
            setPostCode(value);
        }
    };
    (0,react.useEffect)(function() {
        if (stores === null || stores === void 0 ? void 0 : stores.selectedStore) {
            setOpen(false);
        } else {
            setOpen(true);
        }
    }, [
        stores === null || stores === void 0 ? void 0 : stores.selectedStore
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
            fullScreen: (doc === null || doc === void 0 ? void 0 : doc.modal_full_screen_on_mobile) ? (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm')) : false,
            open: open,
            maxWidth: 'lg',
            className: classes.root,
            scroll: 'paper',
            disableBackdropClick: true,
            children: doc !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(classes.closeButton),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                component: "h2",
                                className: "".concat(classes.titleInHeader),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: doc === null || doc === void 0 ? void 0 : doc.modale_title,
                                    defaultText: ''
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                            className: classes.dialogContent,
                            children: [
                                (doc === null || doc === void 0 ? void 0 : doc.enable_postcode_search) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.search,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : doc.search_input_label,
                                                defaultText: t('texts:instore:search_input_label')
                                            }),
                                            name: "search-postcode",
                                            placeholder: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : doc.search_input_placeholder, t('texts:instore:search_input_placeholder')),
                                            value: postCode,
                                            type: 'number',
                                            maxLength: 5,
                                            onChange: setPostCodeFunction,
                                            onKeyPress: searchStoreOnEnter
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "submit",
                                            variant: 'contained',
                                            className: classes.searchButton,
                                            color: 'secondary',
                                            size: 'small',
                                            onClick: searchStore,
                                            disabled: postCode === '',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : doc.search,
                                                defaultText: t('texts:instore:search')
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InStore_StoreList, {
                                    doc: doc,
                                    t: t,
                                    origin: stores === null || stores === void 0 ? void 0 : stores.deleteOrigin,
                                    stores: (doc === null || doc === void 0 ? void 0 : doc.enable_postcode_search) ? searchedWarehouse1 : parameters === null || parameters === void 0 ? void 0 : (ref1 = parameters.items) === null || ref1 === void 0 ? void 0 : ref1.stores,
                                    handleClose: handleClose
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }));
};
/* harmony default export */ var InStore_InStoreModal = ((0,es/* connect */.$j)(InStoreModal_mapStateToProps)(InStoreModal));

;// CONCATENATED MODULE: ./components/InStoreManager.tsx







var InStoreManager_mapStateToProps = function(state) {
    return {
        stores: state.stores,
        parameters: state.parameters
    };
};
var InStoreManager_mapDispatchToProps = {
    saveChosenStore: inStore/* saveChosenStore */.c3,
    deleteChosenStore: inStore/* deleteChosenStore */.ZY
};
var InStoreManager = function(param) {
    var children = param.children, stores = param.stores, saveChosenStore1 = param.saveChosenStore, parameters = param.parameters, deleteChosenStore1 = param.deleteChosenStore;
    var ref18, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref3 = (0,react.useState)(false), showModale = ref3[0], setShowModale = ref3[1];
    var noModalepaths = [
        '/',
        '/faq',
        '/account',
        '/register',
        '/account/informations/',
        '/confirmation', 
    ];
    (0,react.useEffect)(function() {
        var ref, ref4, ref5, ref6, ref7, ref8, ref9;
        if (router && (router === null || router === void 0 ? void 0 : router.query) && (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.store) && (parameters === null || parameters === void 0 ? void 0 : (ref4 = parameters.items) === null || ref4 === void 0 ? void 0 : ref4.in_store)) {
            var ref10;
            var queryStore = router === null || router === void 0 ? void 0 : (ref10 = router.query) === null || ref10 === void 0 ? void 0 : ref10.store;
            var foundShop = parameters.items.stores.find(function(store) {
                return (store === null || store === void 0 ? void 0 : store.slug) === queryStore;
            });
            if (foundShop) {
                localStorage.setItem('selectedStore', JSON.stringify(foundShop));
            } else {
                localStorage.removeItem('selectedStore');
                deleteChosenStore1(router.asPath);
            }
        }
        // handle redirection when on cgl page
        if (typeof (router === null || router === void 0 ? void 0 : (ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.uid) !== 'undefined' && typeof (stores === null || stores === void 0 ? void 0 : (ref6 = stores.selectedStore) === null || ref6 === void 0 ? void 0 : ref6.slug) !== 'undefined') {
            var ref11, ref12, ref13, ref14, ref15;
            var pagesUidParameter = typeof (router === null || router === void 0 ? void 0 : (ref11 = router.query) === null || ref11 === void 0 ? void 0 : ref11.uid) === 'string' ? router === null || router === void 0 ? void 0 : (ref12 = router.query) === null || ref12 === void 0 ? void 0 : ref12.uid : router === null || router === void 0 ? void 0 : (ref13 = router.query) === null || ref13 === void 0 ? void 0 : ref13.uid[0];
            if (pagesUidParameter && pagesUidParameter.substring(0, 3) === 'cgl' && pagesUidParameter !== "cgl-".concat(stores === null || stores === void 0 ? void 0 : (ref14 = stores.selectedStore) === null || ref14 === void 0 ? void 0 : ref14.slug) && (stores === null || stores === void 0 ? void 0 : (ref15 = stores.selectedStore) === null || ref15 === void 0 ? void 0 : ref15.slug) !== null) {
                var ref16;
                router.push("cgl-".concat(stores === null || stores === void 0 ? void 0 : (ref16 = stores.selectedStore) === null || ref16 === void 0 ? void 0 : ref16.slug));
            }
        }
        // You can't access the website if you didn't select a store
        if ((parameters === null || parameters === void 0 ? void 0 : (ref7 = parameters.items) === null || ref7 === void 0 ? void 0 : ref7.in_store) && typeof (stores === null || stores === void 0 ? void 0 : stores.selectedStore) === 'undefined' && localStorage.getItem('selectedStore') === null) {
            // return to HP
            if (router.pathname !== '/') {
            //router.push('/')
            }
        }
        if (localStorage.getItem('selectedStore') === null && typeof (stores === null || stores === void 0 ? void 0 : stores.selectedStore) !== 'undefined') {
            var ref17;
            // Save store in local storage when selected
            localStorage.setItem('selectedStore', JSON.stringify(stores === null || stores === void 0 ? void 0 : stores.selectedStore));
            localStorage.setItem('rmsParcelShopId', stores === null || stores === void 0 ? void 0 : (ref17 = stores.selectedStore) === null || ref17 === void 0 ? void 0 : ref17.code);
        }
        if (localStorage.getItem('selectedStore') !== null && typeof (stores === null || stores === void 0 ? void 0 : stores.selectedStore) === 'undefined' && (parameters === null || parameters === void 0 ? void 0 : (ref8 = parameters.items) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.stores) === null || ref9 === void 0 ? void 0 : ref9.length) > 0) {
            // When localStorage has value, refill redux store value
            var storedCode = JSON.parse(localStorage.getItem('selectedStore'));
            var foundStore = parameters.items.stores.find(function(store) {
                return store.code === storedCode.code;
            });
            saveChosenStore1(foundStore !== null && foundStore !== void 0 ? foundStore : storedCode);
        }
    }, [
        stores === null || stores === void 0 ? void 0 : stores.selectedStore,
        parameters === null || parameters === void 0 ? void 0 : (ref18 = parameters.items) === null || ref18 === void 0 ? void 0 : ref18.in_store
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.in_store) && !(stores === null || stores === void 0 ? void 0 : stores.selectedStore)) {
            setShowModale(true);
        }
    }, [
        stores === null || stores === void 0 ? void 0 : stores.selectedStore,
        parameters === null || parameters === void 0 ? void 0 : (ref1 = parameters.items) === null || ref1 === void 0 ? void 0 : ref1.in_store
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (parameters === null || parameters === void 0 ? void 0 : (ref2 = parameters.items) === null || ref2 === void 0 ? void 0 : ref2.in_store) && showModale && /*#__PURE__*/ (0,jsx_runtime.jsx)(InStore_InStoreModal, {
                t: t
            }),
            children
        ]
    }));
};
/* harmony default export */ var components_InStoreManager = ((0,es/* connect */.$j)(InStoreManager_mapStateToProps, InStoreManager_mapDispatchToProps)(InStoreManager));


/***/ }),

/***/ 7766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZY": function() { return /* binding */ deleteChosenStore; },
  "f0": function() { return /* binding */ inStore_getStoresByOrderId; },
  "c3": function() { return /* binding */ saveChosenStore; }
});

// UNUSED EXPORTS: ACTIONS, DELETE_CHOSEN_STORE, GET_STORES_BY_ORDER_NUMBER_FAILURE, GET_STORES_BY_ORDER_NUMBER_REQUEST, GET_STORES_BY_ORDER_NUMBER_SUCCESS, SAVE_CHOSEN_STORE

// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./redux/services/inStore.ts




var getStoresByOrderId = function(orders) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.warehouseOrder */.KU.warehouseOrder,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE)),
        data: {
            orders: orders
        }
    });
};

;// CONCATENATED MODULE: ./redux/actions/inStore.ts

var ACTIONS = {
    GET_STORES_BY_ORDER_NUMBER_REQUEST: 'GET_STORES_BY_ORDER_NUMBER_REQUEST',
    GET_STORES_BY_ORDER_NUMBER_SUCCESS: 'GET_STORES_BY_ORDER_NUMBER_SUCCESS',
    GET_STORES_BY_ORDER_NUMBER_FAILURE: 'GET_STORES_BY_ORDER_NUMBER_FAILURE',
    SAVE_CHOSEN_STORE: 'SAVE_CHOSEN_STORE',
    DELETE_CHOSEN_STORE: 'DELETE_CHOSEN_STORE'
};
var GET_STORES_BY_ORDER_NUMBER_REQUEST = function() {
    return {
        type: ACTIONS.GET_STORES_BY_ORDER_NUMBER_REQUEST
    };
};
var GET_STORES_BY_ORDER_NUMBER_SUCCESS = function(stores) {
    return {
        type: ACTIONS.GET_STORES_BY_ORDER_NUMBER_SUCCESS,
        stores: stores
    };
};
var GET_STORES_BY_ORDER_NUMBER_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_STORES_BY_ORDER_NUMBER_FAILURE,
        err: err
    };
};
function inStore_getStoresByOrderId(orders) {
    return function(dispatch) {
        dispatch(GET_STORES_BY_ORDER_NUMBER_REQUEST());
        return getStoresByOrderId(orders).then(function(response) {
            return dispatch(GET_STORES_BY_ORDER_NUMBER_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_STORES_BY_ORDER_NUMBER_FAILURE(err));
        });
    };
}
var SAVE_CHOSEN_STORE = function(selectedStore) {
    return {
        type: ACTIONS.SAVE_CHOSEN_STORE,
        selectedStore: selectedStore
    };
};
function saveChosenStore(data) {
    return function(dispatch) {
        dispatch(SAVE_CHOSEN_STORE(data));
    };
}
var DELETE_CHOSEN_STORE = function(deleteOrigin) {
    return {
        type: ACTIONS.DELETE_CHOSEN_STORE,
        deleteOrigin: deleteOrigin
    };
};
function deleteChosenStore(data) {
    return function(dispatch) {
        dispatch(DELETE_CHOSEN_STORE(data));
    };
}


/***/ })

}]);